import actionCreatorFactory from 'typescript-fsa';
import { ErrorWrapper, NotFoundErrorWrapper } from 'store/base';
import CommonUtilities from 'helpers/CommonUtilities';
import { Dispatch } from 'redux';
import { ShippingOrderApi } from 'api/ShippingOrder.api';
import ShippingOrderPublicViewModel from 'viewModels/shippingOrder/ShippingOrderPublicViewModel';

const actionCreator = actionCreatorFactory();

export const asyncActions = actionCreator.async<{}, {}, ErrorWrapper>('APP/SHIPPING_ORDER/START');

export default function startShippingOrderConfirmation(tenantCode: string, token: string) {
  let result: ShippingOrderPublicViewModel = new ShippingOrderPublicViewModel();

  return async (dispatch: Dispatch<any>) => {
    async function mainAction() {
      dispatch(asyncActions.started({}));

      const data = await ShippingOrderApi.getPublicSO(tenantCode, token);

      if (!data) {
        throw new NotFoundErrorWrapper(`Item not found`);
      }
      result = data;

      dispatch(asyncActions.done({ params: {}, result: {} }));
    }

    async function catchAction(exception: ErrorWrapper) {
      dispatch(asyncActions.failed({ params: {}, error: exception }));
    }

    await CommonUtilities.tryCatchWrapper(mainAction, catchAction);

    return result;
  };
}